import React, { useState, useContext, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { partnerService } from "../../Services/partner.service";
import CardWrap from "../Common/CardWrap";
import ResultModal from "../Common/ResultModal";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { globalServices } from "../../Services/global.service";
import { iban, numbersOnly, lettersOnly, lettersAndNumbers, address, email, OIB } from "../../Config/Regex";
import Select from "react-select";
import Tooltip from "../Common/Tooltip";
import { validationService } from "../../Services/validation.service";

export default function AddPartner() {
  const { t: translator } = useTranslation();
  const { locName, locTenant } = useContext(GlobalContext);
  const { register, handleSubmit, errors, control, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const history = useHistory();
  const [tenants, setTenants] = React.useState();
  const [countries, setCountries] = useState([]);
  const [postOffices, setPostOffices] = useState([]);
  const [isCroatia, setIsCroatia] = useState(true);
  const [isDisabled, setDisable] = useState(true);
  const initialState = {
    tenantId: null,
    name: "",
    description: "",
    taxNumber: "",
    street: "",
    streetNumber: null,
    streetNumberExtension: "",
    city: "",
    countryId: 1,
    postalNumber: "",
    iban: "",
    email: "",
    phone: "",
    discount: 0,
  };

  const [partner, setPartner] = useState(initialState);
  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });
  const [city, setCity] = useState("");

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setPartner({ ...partner, [name]: value });
  };

  const handlePostalNumberChange = (pbr) => {
    setDisable(false);
    setPartner({ ...partner, postalNumber: pbr });
  };

  const goBack = () => {
    history.push(`/${locName}/${locTenant}`);
  };

  const handleClose = () => {
    setModal({ show: false });
    if (modal.success === true) {
      goBack();
    }
  };

  useEffect(() => {
    globalServices
      .getTenants()
      .then((data) => {
        setTenants(data.data);
      })
      .catch(() => history.push("/Error"));

    globalServices
      .getCountries()
      .then((res) => setCountries(res.data))
      .catch((err) => console.log(err));

    globalServices
      .getPostOffices()
      .then((data) => {
        setPostOffices(data.data);
      })
      .catch(() => history.push("/Error"));
  }, []);

  const onSubmit = (data) => {
    partnerService
      .create({
        tenantId: Number(locTenant),
        name: data.name,
        description: data.description,
        taxNumber: data.taxNumber,
        street: data.street,
        streetNumber: Number(data.streetNumber),
        streetNumberExtension: data.streetNumberExtension,
        city: isCroatia ? city : data.city,
        countryId: Number(data.countryId),
        postalNumber: isCroatia
          ? data.postalNumber != undefined
            ? data.postalNumber.value
            : ""
          : data.postalNumber,
        iban: data.iban,
        email: data.email,
        phone: data.phone,
        discount: data.discount,
        branch: data.branch,
      })
      .then((res) => {
        res.data.success
          ? setModal({
            show: true,
            title: translator("Partner-AddPartner-SuccessModalTitle"),
            text: translator("Partner-AddPartner-SuccessModalText"),
            btnClass: "btn btn-primary",
            success: true,
          })
          : setModal({
            show: true,
            title: translator("Partner-AddPartner-UnsuccessModalTitle"),
            text: translator("Partner-AddPartner-UnuccessModalText"),
            btnClass: "btn btn-primary",
            success: true,
          });
      })
      .catch((err) =>
        setModal({
          show: true,
          title: translator("Partner-AddPartner-UnsuccessModalTitle"),
          text: translator("Partner-AddPartner-UnuccessModalText"),
          btnClass: "btn btn-primary",
          success: true,
        })
      );
  };

  const handleCancel = () => {
    goBack();
  };

  const getCity = (id, postal) => {
    globalServices
      .getCityByPostOffice(id)
      .then((res) => {
        document.getElementsByName("city")[0].value = res.data.data.name;
        setCity(res.data.data.name);
        document.getElementsByName("city-hidden")[0].value = res.data.data.name;
      })
      .catch(() => history.push("/Error"));
  };

  return (
    <CardWrap subtitle={translator("Partner-AddPartner-Subtitle")}>
      <form onSubmit={handleSubmit(onSubmit)} className="row">
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Partner-UpdatePartner-MainData")}
            </legend>
            <div className="form-group">
              <label>{translator("Partner-UpdatePartner-OIB")}</label>{" "}
              <Tooltip text={translator("Partner-OIB-Msg")} />
              <input
                type="text"
                className="form-control"
                ref={register({
                  required: true,
                  pattern: isCroatia ? OIB : null,
                  validate: () =>
                    isCroatia //&& partner.branch
                      ? validationService.validateUserOib(
                        document.getElementsByName("taxNumber")[0].value
                      )
                      : null,
                })}
                name="taxNumber"
              />
              {errors.taxNumber && errors.taxNumber.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.taxNumber && errors.taxNumber.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-OIBLength")}
                </p>
              )}
              {errors.taxNumber && errors.taxNumber.type === "validate" && (
                <p className="text-danger">
                  {translator("ValidationMsg-OIBNotValid")}
                </p>
              )}
              <p>*{translator("AddPartner-MsgChangeState")}</p>
            </div>
            <div className="form-group">
              <label>{translator("Partner-UpdatePartner-Name")}</label>{" "}
              <Tooltip text={translator("Partner-Name-Msg")} />
              <input
                type="text"
                className="form-control"
                ref={register({
                  required: true,
                  maxLength: 100,
                })}
                name="name"
              />
              {errors.name && errors.name.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.name && errors.name.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength100")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>{translator("Partner-UpdatePartner-Branch")}</label>{" "}
              <Tooltip text={translator("Partner-Branch-Msg")} />
              <input
                type="text"
                className="form-control"
                ref={register({
                  required: false,
                  maxLength: 100,
                })}
                name="branch"
              />
              {errors.name && errors.name.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.name && errors.name.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength100")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>{translator("PartnersAdd-IBAN")}</label>{" "}
              <Tooltip text={translator("Partner-IBAN-Msg")} />
              <input
                type="text"
                className="form-control"
                ref={register({
                  required: false,
                  pattern: isCroatia ? iban : null,
                })}
                name="iban"
              />
              {errors.iban && errors.iban.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-IBAN")}
                </p>
              )}
              <p>*{translator("AddPartner-MsgChangeStateIban")}</p>
            </div>
           
          </fieldset>
        </div>
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Partner-UpdatePartner-AdressData")}
            </legend>
            <div className="form-group">
              <label>{translator("Partner-UpdatePartner-Street")}</label>{" "}
              <Tooltip text={translator("Partner-Street-Msg")} />
              <input
                type="text"
                className="form-control"
                ref={register({
                  required: false,
                  pattern: address,
                  maxLength: 150,
                })}
                name="street"
              />
              {errors.street && errors.street.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-LettersOnly")}
                </p>
              )}
              {errors.street && errors.street.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength150")}
                </p>
              )}
            </div>
            <div className="form-row">
              <div className="form-group col-md-8">
                <label htmlFor="streetNumber">
                  {translator("Partner-UpdatePartner-StreetNumber")}{" "}
                  <Tooltip text={translator("Partner-StreetNumber-Msg")} />
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="streetNumber"
                  ref={register({
                    required: false,
                    pattern: numbersOnly,
                    maxLength: 6,
                  })}
                />
                {errors.streetNumber &&
                  errors.streetNumber.type === "pattern" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-NumbersOnly")}
                    </p>
                  )}
                {errors.streetNumber &&
                  errors.streetNumber.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength6")}
                    </p>
                  )}
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="streetNumberExtension">
                  {translator("Partner-UpdatePartner-StreetNumberExtension")}
                </label>{" "}
                <Tooltip
                  text={translator("Partner-StreetNumberExtension-Msg")}
                />
                <input
                  type="text"
                  className="form-control"
                  name="streetNumberExtension"
                  ref={register({ maxLength: 10 })}
                />
                {errors.streetNumberExtension &&
                  errors.streetNumberExtension.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength10")}
                    </p>
                  )}
              </div>
            </div>
            {isCroatia ? (
              <div className="form-row">
                <div className="form-group col-md-5">
                  <label htmlFor="streetNumberExtension">
                    {translator("Partner-UpdatePartner-ZipCode")}
                  </label>{" "}
                  <Tooltip text={translator("Partner-ZipCode-Msg")} />
                  <Controller
                    as={Select}
                    options={
                      postOffices &&
                      postOffices.map((p) => ({
                        id: p.id,
                        label: p.name,
                        value: p.name,
                      }))
                    }
                    name="postalNumber"
                    placeholder=""
                    rules={{ required: false }}
                    control={control}
                    onChange={function (event) {
                      getCity(event[0].id, event[0].label);
                      return event[0];
                    }}
                  />
                </div>
                <div className="form-group col-md-7">
                  <label htmlFor="streetNumber">
                    {translator("Partner-UpdatePartner-City")}
                  </label>{" "}
                  <Tooltip text={translator("Partner-City-Msg")} />
                  <input
                    disabled
                    type="text"
                    className="form-control"
                    name="city-hidden"
                  />
                  <input type="hidden" className="form-control" name="city" />
                </div>
              </div>
            ) : (
              <div className="form-row">
                <div className="form-group col-md-5">
                  <label htmlFor="streetNumberExtension">
                    {translator("Partner-UpdatePartner-ZipCode")}
                  </label>{" "}
                  <input
                    type="text"
                    className="form-control"
                    name="postalNumber"
                    ref={register({
                      maxLength: 10,
                      required: false,
                      pattern: numbersOnly,
                    })}
                  />
                  {errors.postalNumber &&
                    errors.postalNumber.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength10")}
                      </p>
                    )}
                  {errors.postalNumber &&
                    errors.postalNumber.type === "pattern" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-NumbersOnly")}
                      </p>
                    )}
                </div>
                <div className="form-group col-md-7">
                  <label htmlFor="streetNumber">
                    {translator("Partner-UpdatePartner-City")}
                  </label>{" "}
                  <input
                    type="text"
                    className="form-control"
                    name="city"
                    ref={register({
                      maxLength: 100,
                      required: false,
                      pattern: lettersOnly,
                    })}
                  />
                  {errors.city && errors.city.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength100")}
                    </p>
                  )}
                  {errors.city && errors.city.type === "pattern" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-LettersOnly")}
                    </p>
                  )}
                </div>
              </div>
            )}

            <div className="form-group">
              <label>{translator("Partner-UpdatePartner-State")}</label>
              <select
                className="form-control"
                name="countryId"
                ref={register({ required: false })}
                onChange={(e) => {
                  if (e.target.value == 1) {
                    setIsCroatia(true);
                  } else {
                    setIsCroatia(false);
                  }
                }}
              >
                {countries.map((e, key) => {
                  return (
                    <option key={key} value={e.id}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </div>
             <div className="form-group">
              <label>{translator("Partner-UpdatePartner-Description")}</label>{" "}
              <Tooltip text={translator("Partner-Description-Msg")} />
              <textarea
                id="textArea"
                rows="4"
                className="form-control"
                name="description"
                ref={register({ maxLength: 250 })}
              />
              {errors.description &&
                errors.description.type === "maxLength" && (
                  <p className="text-danger">
                    {translator(
                      "ValidationMsg-MaxLength-HundredAndFiftyCharacters"
                    )}
                  </p>
                )}
            </div>
          </fieldset>
        </div>
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Partner-UpdatePartner-ContactData")}
            </legend>
            <div className="form-group">
              <label>Email</label>{" "}
              <Tooltip text={translator("Partner-Email-Msg")} />
              <input
                type="text"
                className="form-control"
                ref={register({
                  required: false,
                  pattern: email,
                  maxLength: 254,
                })}
                name="email"
              />
              {errors.email && errors.email.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-Email")}
                </p>
              )}
              {errors.email && errors.email.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-Email")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>{translator("Partner-UpdatePartner-PhoneNumber")}</label>{" "}
              <Tooltip text={translator("Partner-PhoneNumber-Msg")} />
              <input
                type="text"
                className="form-control"
                ref={register({
                  required: false,
                  pattern: numbersOnly,
                  maxLength: 20,
                })}
                name="phone"
              />
              {errors.phone && errors.phone.type === "maxLength" && (
                <p className="text-danger">
                  {translator("ValidationMsg-MaxLength20")}
                </p>
              )}
              {errors.phone && errors.phone.type === "pattern" && (
                <p className="text-danger">
                  {translator("ValidationMsg-NumbersOnly")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>{translator("Partner-UpdatePartner-Discount")}</label>{" "}
              <Tooltip text={translator("Item-ConsummationTax-Msg")} />
              <div className="input-group">
                <input
                  type="number"
                  min="0"
                  step=".01"
                  className="form-control"
                  name="discount"
                  ref={register({ required: false, min: 0, max: 100 })}
                />
                <div className="input-group-append">
                  <span className="input-group-text" id="basic-addon2">
                    %
                  </span>
                </div>
              </div>
              {errors.pp && errors.pp.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.pp &&
                (errors.pp.type === "min" || errors.pp.type === "max") && (
                  <p className="text-danger">
                    {translator("ValidationMsg-PP")}
                  </p>
                )}
            </div>
          </fieldset>
        </div>

        <div
          className="container-fluid"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button className="btn btn-outline-secondary" onClick={handleCancel}>
            {translator("Btn-Cancel")}
          </button>
          &nbsp;
          <button className="btn btn-primary" type="submit">
            {translator("Btn-Save")}
          </button>
        </div>
      </form>
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </CardWrap>
  );
}
